export enum UnsupportedCase {
  'productType',
  'noSSNOwner',
  'noSSNInsured',
  'ownerAndInsuredSameSSN',
  'ownerAndSignerSameSSN',
  'insuredAndSignerSameSSN',
  'ownerAndJointOwnerSameSSN',
  'ownerAndContingentOwnerSameSSN',
  'ownerAndAdditionalPayerSameSSN',
  'noTIN',
  'noEIN',
  'isUSEntity',
  'investment',
  'business',
  'other',
  'none',
  'unknown',
  'citizen',
  'nonUSCitizenMaxFace',
  'state',
  'stateWL',
  'military',
  'premium',
  'hiv',
  'collateral',
  'replacements',
  'isTINCorrect',
  'isDOL',
  'FATCAWitholding',
  'economic',
  'sell',
  'alternate',
  'tin',
  'replaceOther',
  'replaceWhole',
  'replaceCompanies', //MassMutual or Northwestern Mutual not allowed
  'replaceNorthwesternMutual',
  'isReplacementOther',
  'lifeBridge',
  'ownerIsNotPayer',
  'isJuviPilot',
  'reimburseMethod',
  'paymentInApplication',
  'contingent',
  'girRider',
  'rtrRider',
  'entityFaceAmountExceeded',
  'juveToAdultOrAdultToJuve',
  'noTaxIdTrust',
  'invalidAgeForProducts',
  'signerNotParentOrGuardian',
  'wholeLife15',
  'prefillOwnerAddressWithInsured',
  'alirLumpSumAtTimeOfIssuance',
  'alirScheduledPaymentsWL15',
  'invalidRtrRemoval',
  'invalidGirRemoval',
  'invalidWopRemoval',
  'alir1035',
  'alirWithNoScheduledPayments',
  'firstYearPremiumWith1035',
  'scheduledPaymentWith1035',
  'alirCompoundValidation',
  'replacementLoanWith1035',
  'multipleCashValueReplacements',
  'cashValueTransfer',
  'replacementLoanAmount',
  'termPolicyWith1035',
  'genericUnsupportedMessage',
  'alirNoOptionSelected',
  'cirMinimumFaceAmount',
  'cirCompoundError',
  'invalidSourceOfFunds',
  'alirOwnerExclusion',
}

export const ReasonForInsurance = {
  investment: 'I',
  business: 'B',
  other: 'O',
  none: 'N',
  unknown: 'U',
};

export const UnsupportedStatesAnnuity = ['NY', 'CA', 'CT', 'RI', 'AZ', 'IA', 'FL', 'PR'];

const UnsupportedCaseTextStart = 'We’re sorry! Currently we aren’t ready to ';
const UnsupportedCaseTextMiddle = 'If you made a mistake, you can go back to the previous question and re-answer it.';

export const ValidationErrorMessages = {
  samePaymentInfoError: 'Your bank account number and bank routing number can’t be the same.',
};

export const UnsupportedCaseText = {
  productType:
    'We’re sorry! Currently we aren’t ready to support whole life policies.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase a whole life policy, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  noSSNOwner:
    'We’re sorry! Currently we aren’t ready to support policy owners who do not have an SSN. Please enter a valid SSN if you have one.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do not have an SSN, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  noSSNInsured:
    'We’re sorry! Currently we aren’t ready to support insureds who do not have an SSN or TIN. Please enter a valid SSN or TIN if you have one.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do not have an SSN or TIN, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  ownerAndInsuredSameSSN:
    'The insured and owner are different people according to the application, they cannot have the same SSN.|' +
    'Please revise the application or contact your advisor for assistance.',
  ownerAndSignerSameSSN:
    'The signer and owner are different people according to the application, they cannot have the same SSN.|' +
    'Please revise the application or contact your advisor for assistance.',
  insuredAndSignerSameSSN:
    'The signer and insured are different people according to the application, they cannot have the same SSN.|' +
    'Please revise the application or contact your advisor for assistance.',
  ownerAndJointOwnerSameSSN:
    'The owner and the joint owner must always be different people and cannot have the same SSN.|' +
    'Please revise the application or contact your advisor for assistance.',
  ownerAndContingentOwnerSameSSN:
    'The owner and the contingent owner must always be different people and cannot have the same SSN.|' +
    'Please revise the application or contact your advisor for assistance.',
  ownerAndAdditionalPayerSameSSN:
    'The owner and the additional payer must always be different people and cannot have the same SSN.|' +
    'Please revise the application or contact your advisor for assistance.',
  noEIN:
    'We’re sorry! Currently we aren’t ready to support entities who do not have an EIN. Please enter a valid EIN if you have one.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do not have an EIN, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  noTIN:
    'We’re sorry! Currently we aren’t ready to support entities who do not have a TIN or an EIN. Please enter a valid TIN or EIN if you have one.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do not have a TIN or an EIN, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  isUSEntity:
    'We’re sorry! Currently we aren’t ready to support entities who are not U.S. entities.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you are not a U.S. entity, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  investment:
    "We're sorry! Currently we aren't ready to sell policies that support purchasing for investment reasons.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase a policy for investment reasons, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  business:
    "We're sorry! Currently we aren't ready to sell policies that support purchasing for business reasons.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase a policy for business reasons, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  other:
    "We're sorry! Currently we aren't ready to sell policies that support purchasing for other reasons.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase a policy for other reasons, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  none:
    "We're sorry! Currently we aren't ready to sell policies that support purchasing for no reason.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase a policy for no reason, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  unknown:
    "We're sorry! Currently we aren't ready to sell policies that support purchasing for unknown reasons.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase a policy for no reason, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  citizen:
    "We're sorry! Currently we aren't ready to sell policies that support non-U.S. residents.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you are not a U.S. resident, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  nonUSCitizenMaxFace:
    "We're sorry! Currently we aren't ready to sell policies that support non-U.S. residents if the total face amount exceeds $1,000,000.00.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you are not a U.S. resident, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  isOutOfAgeRangeWL100:
    "We're sorry! Currently we aren't ready to sell Whole Life policies if the insured's age is not between 18-64.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  over60over1mWL100:
    "We're sorry! Currently we aren't ready to sell Whole Life policies with face amounts greater than $1,000,000 if the insured's age is between 61-64.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  under60over3mWL100:
    "We're sorry! Currently we aren't ready to sell Whole Life policies with face amounts greater than $3,000,000 if the insured's age is between 18-60.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  isOutOfAgeRangeWL65:
    "We're sorry! Currently we aren't ready to sell Whole Life policies if the insured's age is not between 18-49.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  isOutOfAgeRangeWLShort:
    "We're sorry! Currently we aren't ready to sell Whole Life policies if the insured's age is not between 18-64.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  state:
    "We're sorry! Currently we aren't ready to sell policies for owners living in your state.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  stateWL:
    "We're sorry! Currently we aren't ready to sell Whole Life policies for owners living in your state.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  military:
    "We're sorry! Currently we aren't ready to sell policies that support current or anticipating military personnel.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you are currently a member of the Armed Forces or have a written agreement to become a member, ' +
    'please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  premium:
    "We're sorry! Currently we aren't ready to sell policies that support paying the premium by means other than income, " +
    'savings, or gifts/inheritance.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  hiv:
    "We're sorry! By opting out of HIV testing you may not continue the application process.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  collateral:
    "We're sorry! Currently we aren't ready to sell policies that support collateral assignment.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase a policy for collateral assignment, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  replacements:
    "We're sorry! Currently we aren't ready to sell policies that are replacing previous coverage.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to replace a policy, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  isTINCorrect:
    'We’re sorry! You can’t proceed until you correct your SSN/Tax ID.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you cannot attest that you’ve entered the correct Taxpayer Identification number in the BASICS section, ' +
    'please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  FATCAWitholding:
    'We’re sorry! Currently we aren’t ready to support individuals who are subject to backup withholding.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you are subject to backup withholding, please exit the application and contact your financial professional to discuss a policy that better suits your needs.|',
  isDOL:
    'We’re sorry! Currently we aren’t ready to sell policies that support withdrawals from a retirement account.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to withdrawal from a retirement account in order to purchase a policy, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  economic:
    "We're sorry! Currently we aren't ready to sell policies that support economic incentives or " +
    'entitle a lender or investor a portion of the death benefit.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you did not make a mistake, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  sell:
    "We're sorry! Currently we aren't ready to support selling, transferring, or assigning a policy.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to sell, transfer, or assign a policy, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  alternate:
    "We're sorry! Currently we aren't ready to support alternative or additional policies.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase an alternate or additional policy, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  replaceOther:
    "We're sorry! Currently, we aren't ready to sell policies that support replacing an existing policy that is not a term or whole life policy.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to replace a policy that is not a term or whole life policy, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  replaceWhole:
    "We're sorry! Currently, we aren't ready to sell Whole Life policies that are replacing previous coverage. |" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to replace a policy that is not a term or whole life policy, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  replaceCompanies:
    "We're sorry! Currently, we aren't ready to sell policies that support replacing a MassMutual or Northwestern Mutual policy.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to replace a policy that is not a MassMutual or Northwestern Mutual policy, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  replaceNorthwesternMutual:
    "We're sorry! Currently, we aren't ready to sell policies that support replacing a Northwestern Mutual policy.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to replace a policy that is not a Northwestern Mutual policy, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  isReplacementOther: 'Please add the additional policy (or policies) information above.',
  lifeBridge: 'You may be eligible for MassMutual’s LifeBridge program, learn more at www.massmutual.com/lifebridge.',
  ownerIsNotPayer: `We're sorry! Currently we aren't ready to support policies where the owner is not the payer.
                        If you made a mistake, you can go back to the previous question and re-answer it`,
  isJuviPilot: `We're sorry! Currently we aren't ready to sell policies that support juveniles who are pilots, student pilots or crew members of any aircraft.
                    If you made a mistake, you can go back to the previous question and re-answer it.
                    If you did not make a mistake, please exit the application and
                    contact your financial professional to discuss a policy that better suits your needs.`,
  reimburseMethod: `We're sorry! Currently we aren't ready to support unused premium to pay for existing or new policies.|
                    If you made a mistake, you can go back to the previous question and re-answer it.|
                    If you did not make a mistake, please exit the application and contact your financial professional to discuss a policy that better suits your needs.|`,
  paymentInApplication:
    "We're sorry! Currently we don't support entering payment details after an application is submitted if the Owner is not the Payor.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.',
  contingent:
    "We're sorry! Currently we aren't ready to sell policies that support contingent ownership.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do intend to purchase a policy for contingent ownership, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  girRider: `We're sorry! Currently we aren't ready to sell this policy with support for the Guaranteed Insurability Rider.|
        If you made a mistake, you can go back to the previous question and re-answer it.|
        If you would like a Guaranteed Insurability Rider on your policy, please exit the application and contact your financial professional to discuss a policy that better suits your needs.|`,
  rtrRider: `We're sorry! Currently we aren't ready to sell this policy with support for the Renewable Term Rider.|
        If you made a mistake, you can go back to the previous question and re-answer it.|
        If you would like a Renewable Term Rider on your policy, please exit the application and contact your financial professional to discuss a policy that better suits your needs.|`,
  entityFaceAmountExceeded:
    "This policy exceeds the amount allowed by the company and can't be issued unless the amount is corrected or the face amount is lowered. Please check your response before proceeding.",
  juveToAdultOrAdultToJuve:
    'Coverpath does not allow applicants to change ages in their application from Juvenile to Adult or Adult to Juvenile.|' +
    'Please contact your advisor and have them send you a different quote if you intend to change from Juvenile to Adult, or Adult to Juvenile.',
  noTaxIdTrust:
    'We’re sorry! Currently we aren’t ready to support trusts who do not have a Tax ID. Please enter a valid Tax ID if you have one.|' +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If the trust does not have a Tax ID, please exit the application and contact your financial professional to discuss a policy that better suits your needs.',
  invalidAgeForProducts:
    "We're sorry! Currently a person of this age cannot apply for the life insurance products in this application.|" +
    'If you made a mistake, you can go back to the previous question and re-answer it.|' +
    'If you do not intend to purchase the insurance products in this application, please exit the application and ' +
    'contact your financial professional to discuss a policy that better suits your needs.',
  signerNotParentOrGuardian: "Only the insured's parent or legal guardian can sign on their behalf.",
  wholeLife15: 'Coverpath does not currently allow adults to apply for Whole Life 15. Please choose another product.',
  prefillOwnerAddressWithInsured:
    "To enter the same address as the insured, please click on the first line of the address and you'll see the option to add it appear beneath.",
  alirLumpSumAtTimeOfIssuance:
    'Coverpath does not currently support unscheduled payments with ALIR. Please contact your financial professional with questions.',
  invalidRtrRemoval: `We're sorry! You can't remove the Renewable Term Rider until you adjust your ALIR payments. Removing this rider would make your current selection for ALIR invalid. Please ask your financial professional about your options.`,
  invalidGirRemoval: `We're sorry! You can't remove the Guaranteed Insurability Rider until you adjust your ALIR payments. Removing this rider would make your current selection for ALIR invalid. Please ask your financial professional about your options.`,
  invalidWopRemoval: `We're sorry! You can't remove the Waiver of Premium Rider until you adjust your ALIR payments. Removing this rider would make your current selection for ALIR invalid. Please ask your financial professional about your options.`,
  alir1035:
    'Coverpath does not currently support 1035 exchanges with ALIR. Please contact your financial professional with questions.',
  alirScheduledPaymentsWL15:
    'We do not currently allow ALIR payments with Whole Life 15. Please contact your financial professional for assistance.',
  alirWithNoScheduledPayments:
    'Coverpath only supports ALIR with scheduled payments. If you want to use ALIR without scheduled payments, please contact your financial professional.',
  firstYearPremiumWith1035:
    'Coverpath does not currently support paying first-year premium with 1035 funds, please contact your financial professional to learn about your options.',
  scheduledPaymentWith1035:
    'Coverpath does not currently allow 1035 exchanges and scheduled payments. Please contact your financial professional to learn about your options.',
  alirCompoundValidation:
    'The change you attempted to make is not allowed. Please contact your financial professional.',
  replacementLoanWith1035:
    'Coverpath does not currently allow 1035 exchanges with loans. Please contact your financial professional to learn more about your options.',
  multipleCashValueReplacements:
    'Coverpath only allows one policy with cash value to be replaced per application. Please contact your financial professional if you have questions.',
  cashValueTransfer:
    'Coverpath does not currently allow 1035 exchanges. Please contact your financial professional to learn more about your options.',
  replacementLoanAmount:
    'Coverpath does not currently allow 1035 exchanges with loans. Please contact your financial professional to learn more about your options.',
  termPolicyWith1035:
    'Replacements with cash value are only allowed on whole life policies. Contact your financial professional if you need help.',
  genericUnsupportedMessage: `We're sorry! We don't currently support the option you selected. Please check your answer and try again. Contact your financial professional if you need help.`,
  alirNoOptionSelected: `We're sorry! You can't add the Additional Life Insurance Rider unless you select "Yes" to one of the given options. Please contact your financial professional if you need help.`,
  cirMinimumFaceAmount: `We do not allow CIR to be selected for policies with less than $100,000 in base face amount. Contact your financial professional if you need help.`,
  invalidSourceOfFunds: 'You cannot submit your application using this approach to funding. Please do not proceed.',
  alirOwnerExclusion: 'Charities cannot add ALIR to MassMutual Whole Life policies.',
};

export const UnsupportedCaseHeader = {
  isReplacementOther: 'Replacement Policy',
  lifeBridge: 'LifeBridge',
  signerNotParentOrGuardian: 'Not Supported',
  ownerAndInsuredSameSSN: 'Not Supported',
  ownerAndSignerSameSSN: 'Not Supported',
  insuredAndSignerSameSSN: 'Not Supported',
  ownerAndJointOwnerSameSSN: 'Not Supported',
  ownerAndContingentOwnerSameSSN: 'Not Supported',
  ownerAndAdditionalPayerSameSSN: 'Not Supported',
  prefillOwnerAddressWithInsured: 'Use our address autocomplete',
  invalidRtrRemoval: 'Not Supported',
  invalidGirRemoval: 'Not Supported',
  invalidWopRemoval: 'Not Supported',
  alirCompoundValidation: "Your change can't be saved",
  multipleCashValueReplacements: 'Not Supported',
  termPolicyWith1035: 'Not Supported',
  genericUnsupportedMessage: 'Not Supported',
  alirNoOptionSelected: 'Not Supported',
  cirCompoundError: "Your change can't be saved",
  invalidSourceOfFunds: 'Not Supported',
  alirOwnerExclusion: 'Not Supported',
};
